import React, { useEffect, useState } from 'react'
// Removed Button, Card imports
import { API } from 'aws-amplify'
import get from 'lodash/get'
// Added CBButton, CBCard imports
import { CBButton, CBCard } from '../../core/components/cbd';

import JSONTree from 'react-json-tree'


const BoomerScanAccountList = ({ initialAccounts, theme, userEmail, deleteCallback, pageLimit = 100 }) => {
    const [accounts, setAccounts] = useState(initialAccounts);
    const [moreAccounts, setMoreAccounts] = useState(initialAccounts.length === pageLimit)

    useEffect(() => {
        setMoreAccounts(accounts.length % pageLimit === 0);
    }, [accounts]);

    async function loadNewAccountPage() {
        //get last key. 'calendarAccountId' for accounts. 'id' for bridge/sync
        const lastKey = get(accounts.at(-1), 'calendarAccountId')
        const parameters = {
            email: userEmail,
            limit: pageLimit,
            exclusiveStartIdString: lastKey,
            action: 'getAccountPage'
        }
        try {
            var responseAccountInfo = await API.get('scan', '/scan', {
                queryStringParameters: parameters,
            })
            const newAccountsPage = get(responseAccountInfo, 'results.accounts') || [];
            if (newAccountsPage.length) {
                setAccounts([...accounts, ...newAccountsPage]);
            } else {
                setMoreAccounts(false);
            }
        } catch (ex) {
            alert('Error: getting new accounts page')
            // console.log(ex.message);
        } finally {

        }
    }

    return (
        <div >
            Accounts:
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-4"> {/* Added gap */}
            {accounts && accounts.map((account) => (
                // Replaced Card with CBCard
                <div key={account.calendarAccountId} className="mb-4"> {/* Added key and adjusted margin */}
                    <div className="mb-2">{account.email} - {account.calendarAccountType}</div> {/* Wrapped text */}
                    {account.errorState != "" && <div className="text-red-700 mb-2">Error State: {account.errorState}</div>} {/* Added margin */}
                    <div className="mb-2"> {/* Added wrapper for JSONTree for potential styling */}
                        <JSONTree
                            data={[account]}
                            hideRoot={true}
                            theme={theme}
                        />
                    </div>
                    {/* Replaced Button with CBButton */}
                    <CBButton type="ternary" onClick={e=>{
                      deleteCallback(account.calendarAccountId)
                    }}
                    // Add type="danger" or similar styling if needed
                    >Delete</CBButton>
                </div>
            ))}
            </div>

            {/* Replaced Button with CBButton */}
            {moreAccounts && <CBButton onClick={() => {
                // Consider replacing alert with a less intrusive notification if CBAlert is available
                alert("load more accounts");
                loadNewAccountPage();
            }}>Load More Accounts</CBButton>}
        </div>
   );
}

export default BoomerScanAccountList;